import React from 'react';
import { Box, Grid, Container } from '@mui/material';
import {
  SectionTitle,
  TourCardV2,
} from 'views/rebranded-module/common/components';
import StyledBox, {
  StyledTourCardV2,
  StyledCarousel,
} from 'views/rebranded-module/location-module/LocationViewV2/components/ToursSection/ToursSection.styles';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import PATHS from 'lib/navigation/paths';

const ToursSection = (props) => {
  const { content, data } = props;
  const btnAction = {
    text: interpolateString(content.LocationPage.tourAction, {
      location: data.location.display_name,
    }),
    path: PATHS.motorcycleTours.slug(data.location.slug),
  };
  const tours = data.current_country_tours;

  const renderTourItem = (tourData, isCarousel = false) => {
    const tourProps = {
      tour: {
        ...tourData,
        tour_type: {
          slug: tourData.tour_type_slug,
          identifier: tourData.tour_type_identifier,
        },
        slug: tourData.tour_slug,
        map:
          tourData.images.length > 0
            ? {
              large_url: tourData.images[0].image_url,
            }
            : null,
      },
      showTagLine: true,
      content: content.TourCardComponent,
      showCarousel: true,
    };

    if (isCarousel) {
      return (
        <Box key={tourData.id} className="TSCardWapper">
          <StyledTourCardV2 showPricingTermsTooltip {...tourProps} />
        </Box>
      );
    }

    return (
      <Grid item xs={12} sm={12} md={6} key={tourData.id}>
        <TourCardV2 showPricingTermsTooltip {...tourProps} />
      </Grid>
    );
  };

  const getTourItems = (isCarousel = false) => {
    const items = [];
    const maxItems = isCarousel ? Infinity : 4; // Show all in carousel, max 4 in grid

    tours.location_tours.slice(0, maxItems).forEach((tourData) => {
      items.push(renderTourItem(tourData, isCarousel));
    });

    if (items.length < 4 && tours.other_tours.length) {
      const remainingSlots = maxItems - items.length;
      tours.other_tours.slice(0, remainingSlots).forEach((tourData) => {
        items.push(renderTourItem(tourData, isCarousel));
      });
    }

    return items;
  };
  return (
    <StyledBox>
      <Container className="LVCustomContainer">
        <Box className="TSContent">
          <SectionTitle
            title={interpolateString(content.LocationPage.tourTitle, {
              location: data.location.display_name,
            })}
            text={interpolateString(content.LocationPage.tourSubtitle, {
              location: data.location.display_name,
            })}
            action={btnAction}
          />
          <Box className="IRSSectionContainer" mt={4}>
            {/* Desktop - Carousel  */}
            <Box className="showDESKTOP">
              <StyledCarousel
                swipeable
                infinite
                arrowOutside
                showDots={false}
                keyBoardControl
                minimumTouchDrag={20}
                renderDotsOutside
                largeDesktopPartialVisibilityGutter={false}
                deskTopItems={4}
                carouselArrow
                renderArrowsWhenDisabled
                customTransition="transform 200ms ease-in">
                {getTourItems(true)}
              </StyledCarousel>
            </Box>

            {/* Mobile/Tablet - Grid */}
            <Box className="showTABLET">
              <Grid container spacing={2}>
                {getTourItems()}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
    </StyledBox>
  );
};

export { ToursSection };
